import { Component, EventEmitter, Input, Output, OnInit} from '@angular/core';

@Component({
    selector: 'pme-switch-consulta-assinatura',
    templateUrl: './switch-consulta-assinatura.component.html',
    styleUrls: ['./switch-consulta-assinatura.component.scss'],
    standalone: false
})
export class SwitchConsultaAssinaturaComponent {
  @Input() selectedToggle:number = 0;
  @Output() onSelectionChanged = new EventEmitter<number>();

  ngOnInit() {
    const selected_tab = localStorage.getItem('selected_tab');
    
    if (selected_tab !== null) {
      this.selectedToggle = Number(selected_tab);
      this.onSelectionChanged.emit(this.selectedToggle);
    }
  }


  toggleSelection(selection: number) {
    this.selectedToggle = selection;
    localStorage.setItem('selected_tab', selection.toString());
    this.onSelectionChanged.emit(this.selectedToggle);
  }

}
